import { COOKIE_MONETATE_ID, COOKIE_CUSTOMER_ID, COOKIE_BRANCH_ID } from 'constants/cookies';

interface Cookies extends Record<string, string | undefined> {
  [COOKIE_CUSTOMER_ID]?: string;
  [COOKIE_BRANCH_ID]?: string;
  [COOKIE_MONETATE_ID]?: string;
}

export const getRequestPropertiesFromCookies = (cookies: Cookies) => ({
  branchId: cookies[COOKIE_BRANCH_ID],
  customerId: cookies[COOKIE_CUSTOMER_ID],
  monetateId: cookies[COOKIE_MONETATE_ID],
});
